// extracted by mini-css-extract-plugin
export default {"container":"TranscriptPage_container__eODR-"};